import { render } from "./password_policy_modal.vue?vue&type=template&id=fbb71984"
import script from "./password_policy_modal.vue?vue&type=script&lang=js"
export * from "./password_policy_modal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/modal/password_policy_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbb71984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbb71984', __exports__)) {
    api.reload('fbb71984', __exports__)
  }
  
  module.hot.accept("./password_policy_modal.vue?vue&type=template&id=fbb71984", () => {
    api.rerender('fbb71984', render)
  })

}


export default __exports__